import { useIntl } from 'react-intl';

// What kind of page a model read, in the reader's words. The kinds come from
// the source ledger, plus "list article" for ranked round-ups.
const KIND_IDS: Record<string, { id: string; defaultMessage: string }> = {
  'list article': { id: 'marketerView.modelBeliefs.pageKind.list', defaultMessage: 'list article' },
  listicle: { id: 'marketerView.modelBeliefs.pageKind.list', defaultMessage: 'list article' },
  brand: { id: 'marketerView.modelBeliefs.pageKind.brand', defaultMessage: 'your own site' },
  competitor: { id: 'marketerView.modelBeliefs.pageKind.competitor', defaultMessage: 'competitor' },
  review: { id: 'marketerView.modelBeliefs.pageKind.review', defaultMessage: 'review site' },
  news: { id: 'marketerView.modelBeliefs.pageKind.news', defaultMessage: 'news and press' },
  marketplace: { id: 'marketerView.modelBeliefs.pageKind.marketplace', defaultMessage: 'marketplace' },
  retailer: { id: 'marketerView.modelBeliefs.pageKind.retailer', defaultMessage: 'retailer' },
  social: { id: 'marketerView.modelBeliefs.pageKind.social', defaultMessage: 'social' },
  reference: { id: 'marketerView.modelBeliefs.pageKind.reference', defaultMessage: 'reference site' },
  other: { id: 'marketerView.modelBeliefs.pageKind.other', defaultMessage: 'other site' },
};

export const usePageKindLabel = (): ((kind: string) => string) => {
  const intl = useIntl();
  return (kind: string) => {
    const message = KIND_IDS[kind];
    return message ? intl.formatMessage(message) : kind;
  };
};

// The same label, but a page the API marks as a brand's own site is named
// as that brand's ("Sheridan's own site"), which says more than "competitor"
// or "other site". The brand's own site keeps "your own site".
// A page from another market, named as such ("another market (GB)"), so a
// reader sees at once why it was not scored.
export const useMarketLabel = (): ((market: string) => string) => {
  const intl = useIntl();
  return (market: string) =>
    intl.formatMessage(
      { id: 'marketerView.modelBeliefs.pageKind.otherMarket', defaultMessage: 'another market ({market})' },
      { market },
    );
};

export const usePageLabel = (): ((kind: string, site?: string | null) => string) => {
  const intl = useIntl();
  const kindLabel = usePageKindLabel();
  return (kind: string, site?: string | null) => {
    if (kind === 'brand' || !site) return kindLabel(kind);
    return intl.formatMessage(
      { id: 'marketerView.modelBeliefs.pageKind.brandSite', defaultMessage: "{brand}'s own site" },
      { brand: site },
    );
  };
};
